export var SPLIT_KILLED = 'killed';
export var NO_CONDITION_MATCH = 'default rule';
export var SPLIT_NOT_FOUND = 'definition not found';
export var SDK_NOT_READY = 'not ready';
export var EXCEPTION = 'exception';
export var SPLIT_ARCHIVED = 'archived';
export var NOT_IN_SPLIT = 'not in split';
export var UNSUPPORTED_MATCHER_TYPE = 'targeting rule type unsupported by sdk';
export var PREREQUISITES_NOT_MET = 'prerequisites not met';
